import React, { useCallback, useEffect } from 'react';
import { ReactNode, useMemo, useContext, createContext, useState } from 'react';
import { Module, SiteContext as SiteContextProps, SubMenuItem, Variables } from './types';
import { useQuery } from '@apollo/client';
import find_modules from './constants/find_modules';
import { FlexBox } from '@ui';
import { StaticImage } from 'gatsby-plugin-image';
import { ScaleLoader } from 'react-spinners';
import { cloneDeep, get } from 'lodash';
import data_fields from './constants/data_fields';
import generateQuery from './functions/generateQuery';
import { client } from '../apollo';

const defaultContext: SiteContextProps = {
	data: {
		articles: [],
		categories: [],
		downloads: [],
		calendar: [],
		images: [],
		news: [],
		forms: [],
		locations: [],
		website: [],
		persons: [],
		groups: []
	},
}

const SiteContext = createContext(defaultContext);

export const SiteContextProvider = ({children}: {children: ReactNode}) => {
	const [data] = useState(defaultContext.data);



	

	const siteContext: SiteContextProps = useMemo(() => {
		return {
			data
		};
	}, [data]);

	// useEffect(() => {
	// 	if (projectData) {
	// 		getModuleData();
	// 	}
	// }, [projectData, getModuleData]);
	console.log(data);

	return (
		<SiteContext.Provider
			value={siteContext}
		>
			{children}
		</SiteContext.Provider>
	);
};

export const useSiteContext = () => {
	return useContext(SiteContext);
};